import Vue from 'vue';
import App from './App.vue';
import '@/assets/styles/common.less';
import '@/assets/styles/variable.less';
import { initTheme } from '@atom/b2c-tokens';
import "@atom/b2c-tokens/dist/variables_750_rem.css";

initTheme();

window.weblog.setConfig({
  appKey: '0e6955586f',
  logPrefix: 'gpkh_cot_scenelist',
  debug: true,
});
new Vue({
  render: h => h(App),
}).$mount('#app');
